module.exports = require("amqplib");


//////////////////
// WEBPACK FOOTER
// external "amqplib"
// module id = 9
// module chunks = 0